export default ({
    name : 'Footer'
    , data () {
        return {
            bizInfoPopupUrl : 'http://www.ftc.go.kr/info/bizinfo/communicationViewPopup.jsp?wrkr_no='
            , linkTermsService : '/terms/terms/service'
            , linkTermsPrivacy : '/terms/terms/privacy'
            , linkMysohoFront : 'https://mysoho.com'
            , footerLogoImgUrl : '/assets/shop/pc/img/common/ft_logo.png'
            , linkQna : '/qna'
        }
    }
    , mounted () {
		this.publisher();
    }
    , created () {
        this.code = 'common_footer';
        this.basic = this.getDetailDataByCode(this.code);
        if (this.basic.data.biz_info != undefined) {
            this.bizInfo = this.basic.data.biz_info;
        }
        if (this.basic.data.shop_info != undefined) {
            this.shopInfo = this.basic.data.shop_info;
        }
        if (this.basic.data.pg_info != undefined) {
            this.pgInfo = this.basic.data.pg_info;
        }
        if (this.basic.data.pg_escrow_info != undefined) {
            this.pgEscrowInfo = this.basic.data.pg_escrow_info;
        }
		if (this.basic.data.celeb != undefined) {
            this.useCeleb = this.basic.data.celeb;
        }
        this.qna = this.getDetailDataByCode('qna');
        return {}
    }
    , computed : {
        isUseBizCompanyName () {
            return (this.isSetBizInfo() && this.bizInfo.biz_company_name.value.length > 0)
        }
        , isUseBizOwnerName () {
            return (this.isSetBizInfo() && this.bizInfo.biz_owner_name.value.length > 0)
        }
        , isUseBizNum () {
            return (this.isSetBizInfo() && this.bizInfo.biz_num.value.length > 0)
        }
        , isUseBizReportNum () {
            return (this.isSetBizInfo() && this.bizInfo.biz_report_num.value.length > 0)
        }
        , isUseBizAddr () {
            return (this.isSetBizInfo() && this.bizInfo.biz_addr1.value.length > 0 && this.bizInfo.biz_addr2.value.length > 0)
        }
        , isUseShopPrivacyManager () {
            return (this.isSetShopInfo() && this.shopInfo.shop_privacy_manager.value.length > 0)
        }
        , isUseShopBizHours () {
            return (this.isSetShopInfo() && this.shopInfo.shop_biz_hours.value.length > 0)
        }
        , isUseShopPhone () {
            return (this.isSetShopInfo() && this.shopInfo.shop_phone.value.length > 0)
        }
        , isUseShopEmail () {
            return (this.isSetShopInfo() && this.shopInfo.shop_email.value.length > 0)
        }
        , bizCompanyName () {
            return this.bizInfo.biz_company_name.value;
        }
        , bizOwnerName () {
            return this.bizInfo.biz_owner_name.value;
        }
        , bizNum () {
            return this.bizInfo.biz_num.value.replace(/(\d{3})(\d{2})(\d{5})/, "$1-$2-$3");
        }
        , bizPopupLink () {
            return this.bizInfoPopupUrl + this.bizInfo.biz_num.value;
        }
        , bizReportNum () {
            return this.bizInfo.biz_report_num.value;
        }
        , bizAddr () {
            return this.bizInfo.biz_addr1.value + " " + this.bizInfo.biz_addr2.value;
        }
        , shopPrivacyManager () {
            return this.shopInfo.shop_privacy_manager.value;
        }
        , shopBizHours () {
            return this.shopInfo.shop_biz_hours.value;
        }
        , shopPhone () {
            return this.shopInfo.shop_phone.value;
        }
        , shopEmail () {
            return this.shopInfo.shop_email.value;
        }
        , linkShopPhone () {
            return "tel:" + this.shopInfo.shop_phone.value;
        }
        , linkShopEmail () {
            return "mailto:" + this.shopInfo.shop_email.value;
        }
		, isCeleb () {
            return (this.isSetCeleb() && this.useCeleb);
        }
        , displayQna() {
            return this.isSetQna() ? this.qna.displayQna : false;
        }
		, linkSohoSearchUrl () {
            return this.getAdminEditMode() ? 'javascript:void(0);' : this.urlSohoSearch
        }
        , targetSohoSearch () {
            return this.getAdminEditMode() ? '' : '_blank'
        }
    }
    , methods : {
		publisher () {
		}
        , isSetBizInfo () {
            return (typeof this.bizInfo != 'undefined')
        }
        , isUseBizInfo () {
            return (
                this.isSetBizInfo() && ( 
                    this.bizInfo.biz_company_name.value.length > 0 || this.bizInfo.biz_owner_name.value.length > 0 || this.bizInfo.biz_num.value.length > 0 || this.bizInfo.biz_report_num.value.length > 0 || this.bizInfo.biz_addr1.value.length > 0 || this.bizInfo.biz_addr2.value.length > 0 
                )
            )
        }
        , isSetShopInfo () {
            return (typeof this.shopInfo != 'undefined')
        }
        , isSetPgInfo () {
            return (typeof this.pgInfo != 'undefined')
        }
        , showBizInfo () {
            //let target = event.target;
            let target = document.querySelector('#footer .info');
            if (target.classList.contains('down')) {
                target.classList.remove('down');
            } else {
                target.classList.add('down');
            }
        }
        , isUsePgEscrow() {
            return (this.isSetPgInfo() && typeof this.pgInfo.pg_use_escrow != 'undefined' && this.pgInfo.pg_use_escrow == 'Y');
        }
		, isSetBizInfoBizNum () {
            return (this.isSetBizInfo() && (typeof this.bizInfo.biz_num != 'undefined'))
        }
		, isSetCeleb () {
            return (typeof this.useCeleb != 'undefined')
        }
        , isSetQna () {
            return ((typeof this.qna != 'undefined') && this.qna.displayQna)
        }
    }
})
